import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/golfnow.png'


const _hoisted_1 = { class: "container main-layout" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-sm text-end" }
const _hoisted_4 = { class: "row dropdowns-row align-items-center mb-3" }
const _hoisted_5 = { class: "col-md-8 d-flex flex-nowrap align-items-center" }
const _hoisted_6 = { class: "facility-dropdown d-flex align-items-center me-3 flex-shrink-0" }
const _hoisted_7 = { class: "dropdown" }
const _hoisted_8 = {
  class: "btn btn-primary-outline dropdown-toggle",
  type: "button",
  id: "facilityDropdown",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_9 = {
  class: "dropdown-menu",
  "aria-labelledby": "facilityDropdown"
}
const _hoisted_10 = ["onClick", "onMouseleave"]
const _hoisted_11 = { class: "course-dropdown d-flex align-items-center flex-shrink-0" }
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = {
  class: "btn btn-primary-outline dropdown-toggle",
  type: "button",
  id: "courseDropdown",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_14 = {
  class: "dropdown-menu",
  "aria-labelledby": "courseDropdown"
}
const _hoisted_15 = ["onClick", "onMouseleave"]
const _hoisted_16 = { class: "col-md-4 text-end" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "page-content" }
const _hoisted_19 = { class: "page-title text-center" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "previous-seasons-section"
}
const _hoisted_23 = {
  key: 0,
  class: "previous-seasons-content"
}
const _hoisted_24 = {
  key: 2,
  class: "no-seasons-message"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeasonComponent = _resolveComponent("SeasonComponent")!
  const _component_StrategyComponent = _resolveComponent("StrategyComponent")!
  const _component_PricingComponent = _resolveComponent("PricingComponent")!
  const _component_CreateSeasonModal = _resolveComponent("CreateSeasonModal")!
  const _component_CreateStrategyModal = _resolveComponent("CreateStrategyModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-sm text-start" }, [
          _createElementVNode("img", {
            class: "img-responsive header-logo",
            src: _imports_0,
            alt: "GolfNow logo image"
          })
        ], -1)),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-sm" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["dp-tab", { active: _ctx.page === 0 }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPage(0)))
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "bi bi-calendar-event me-2" }, null, -1),
            _createTextVNode("Seasons ", -1)
          ]))], 2),
          _createElementVNode("button", {
            class: _normalizeClass(["dp-tab", { active: _ctx.page === 1 }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPage(1)))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "bi bi-wrench ms-3" }, null, -1),
            _createTextVNode("Strategies ", -1)
          ]))], 2),
          _createElementVNode("button", {
            class: "dp-tab logout-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "bi bi-box-arrow-right me-2" }, null, -1),
            _createTextVNode("Logout ", -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "dd-label me-2" }, "Facility:", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.facilityName), 1),
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilities, (f) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: f.id
                  }, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      href: "#",
                      onClick: ($event: any) => (f.id !== undefined ? _ctx.fetchCourses(f.id) : null),
                      onMouseleave: ($event: any) => (_ctx.facilityName = f.name ?? '')
                    }, _toDisplayString(f.name), 41, _hoisted_10)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "dd-label me-2" }, "Course:", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.courseName), 1),
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (c) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: c.id
                  }, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      href: "#",
                      onClick: ($event: any) => (c.id !== undefined ? _ctx.fetchSeasons(c.id) : null),
                      onMouseleave: ($event: any) => (_ctx.courseName = c.name ?? '')
                    }, _toDisplayString(c.name), 41, _hoisted_15)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn add-season-btn", { 'disabled-btn': !_ctx.selectedCourseId, 'd-none': _ctx.page !== 0 }]),
            disabled: !_ctx.selectedCourseId,
            "data-bs-toggle": "modal",
            "data-bs-target": "#createSeasonModal"
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("i", { class: "bi bi-calendar-plus" }, null, -1)
          ]))], 10, _hoisted_17),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn add-strategy-btn", { 'd-none': _ctx.page !== 1 }]),
            "data-bs-toggle": "modal",
            "data-bs-target": "#createStrategyModal"
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("i", { class: "bi bi-plus-circle" }, null, -1)
          ]))], 2),
          (
            (!_ctx.selectedStrategy?.isMultipleWindows &&
              _ctx.pricingWindows.length === 0) ||
            _ctx.selectedStrategy?.isMultipleWindows
          )
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                title: "Add Pricing Window",
                type: "button",
                class: _normalizeClass(["btn add-strategy-btn", { 'd-none': _ctx.page !== 2 }]),
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addPriceWindow && _ctx.addPriceWindow(...args)), ["prevent"]))
              }, [...(_cache[14] || (_cache[14] = [
                _createElementVNode("i", { class: "bi bi-plus-circle" }, null, -1)
              ]))], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("h3", _hoisted_19, [
          _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-calendar-event me-2" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.currentPageTitle), 1)
        ]),
        (_ctx.page === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_ctx.seasons.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSeasons, (s) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: s.id
                      }, [
                        _createVNode(_component_SeasonComponent, {
                          season: s,
                          strategies: _ctx.strategies,
                          courseId: _ctx.selectedCourseId ?? 0,
                          existingSeasons: _ctx.seasons,
                          onSeasonUpdated: _ctx.onSeasonUpdated,
                          onSeasonDeleted: _ctx.onSeasonDeleted,
                          onSeasonDeleteError: _ctx.onSeasonDeleteError,
                          onSeasonCopied: _ctx.onSeasonCopied,
                          onSeasonSaveError: _ctx.onSeasonSaveError
                        }, null, 8, ["season", "strategies", "courseId", "existingSeasons", "onSeasonUpdated", "onSeasonDeleted", "onSeasonDeleteError", "onSeasonCopied", "onSeasonSaveError"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.previousSeasons.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-secondary w-100 text-start", { expanded: _ctx.isPreviousSeasonsExpanded }]),
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.togglePreviousSeasons && _ctx.togglePreviousSeasons(...args)))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([
                'bi',
                _ctx.isPreviousSeasonsExpanded ? 'bi-chevron-up' : 'bi-chevron-down',
              ])
                      }, null, 2),
                      _cache[16] || (_cache[16] = _createTextVNode(" Previous Seasons ", -1))
                    ], 2),
                    (_ctx.isPreviousSeasonsExpanded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previousSeasons, (s) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: s.id
                            }, [
                              _createVNode(_component_SeasonComponent, {
                                season: s,
                                strategies: _ctx.strategies,
                                courseId: _ctx.selectedCourseId ?? 0,
                                existingSeasons: _ctx.seasons,
                                onSeasonUpdated: _ctx.onSeasonUpdated,
                                onSeasonDeleted: _ctx.onSeasonDeleted,
                                onSeasonDeleteError: _ctx.onSeasonDeleteError,
                                onSeasonSaveError: _ctx.onSeasonSaveError,
                                onSeasonCopied: _ctx.onSeasonCopied
                              }, null, 8, ["season", "strategies", "courseId", "existingSeasons", "onSeasonUpdated", "onSeasonDeleted", "onSeasonDeleteError", "onSeasonSaveError", "onSeasonCopied"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currentSeasons.length === 0 && _ctx.previousSeasons.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, " No seasons found for this course. Click the \"+\" button to add a new season. "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.page === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strategies, (strategy) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: strategy.id
                }, [
                  _createVNode(_component_StrategyComponent, {
                    strategy: strategy,
                    facilities: _ctx.facilities,
                    existingStrategies: _ctx.strategies,
                    onStrategySelected: _ctx.onStrategySelected
                  }, null, 8, ["strategy", "facilities", "existingStrategies", "onStrategySelected"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.page === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_PricingComponent, {
                strategy: _ctx.selectedStrategy ?? {},
                pricingWindows: _ctx.pricingWindows,
                onSeasonUpdated: _ctx.onPricingSeasonUpdated
              }, null, 8, ["strategy", "pricingWindows", "onSeasonUpdated"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.selectedCourseId !== null)
      ? (_openBlock(), _createBlock(_component_CreateSeasonModal, {
          key: 0,
          courseId: _ctx.selectedCourseId,
          existingSeasons: _ctx.seasons,
          onSeasonCreated: _ctx.onSeasonCreated
        }, null, 8, ["courseId", "existingSeasons", "onSeasonCreated"]))
      : _createCommentVNode("", true),
    (_ctx.selectedFacilityId !== null)
      ? (_openBlock(), _createBlock(_component_CreateStrategyModal, {
          key: 1,
          facilityId: _ctx.selectedFacilityId,
          existingStrategies: _ctx.strategies,
          onStrategyCreated: _ctx.onStrategyCreated,
          onStrategySelected: _ctx.onStrategySelected
        }, null, 8, ["facilityId", "existingStrategies", "onStrategyCreated", "onStrategySelected"]))
      : _createCommentVNode("", true),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "wrapper" }, null, -1))
  ], 64))
}